import { render, staticRenderFns } from "./MobileFooterCopyright.vue?vue&type=template&id=3fd3c0bc"
import script from "./MobileFooterCopyright.vue?vue&type=script&lang=js"
export * from "./MobileFooterCopyright.vue?vue&type=script&lang=js"
import style0 from "./MobileFooterCopyright.vue?vue&type=style&index=0&id=3fd3c0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports